

/**
* directives.slider Module
*
* Description
*/
var app = angular.module('directives.utilities', [])
	
	require('./index.sass');
    require('./utilities.directive.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/utilities/index.js
 ** module id = 239
 ** module chunks = 1
 **/